import axios from 'axios';

const getPaymentSettingsApi = async (token) => {
  try {
    const res = await axios.get('/payment-methods', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getPaymentSettingsApi;
